import { Table } from "semantic-ui-react";
import { AdminRole } from "../models/AdminRole";
import GridActionButton from "./GridActionButton";

interface Props {
  onEditAdminRole: (adminRoleId: string) => void;
  adminRoles?: AdminRole[];
}

const AdminRolesGrid = ({ onEditAdminRole, adminRoles }: Props) => {
  const renderAdminRoleTableRow = () => {
    if (adminRoles) {
      return adminRoles.map((adminRole) => (
        <Table.Row key={adminRole.id}>
          <Table.Cell>
            {adminRole.name.replace(/^[^_]*_/, "")}
            <GridActionButton
              rowId={adminRole.id}
              items={[{ key: "edit", icon: "edit", content: "Edit", callback: onEditAdminRole }]}
            />
          </Table.Cell>
        </Table.Row>
      ));
    }
  };

  return (
    <>
      <Table basic="very" compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>{renderAdminRoleTableRow()}</Table.Body>

        <Table.Footer>
          <Table.Row textAlign="right">
            <Table.HeaderCell colSpan="4"></Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </>
  );
};

export default AdminRolesGrid;
